import { combineReducers } from 'redux';

const createSslInitialState = {
  type: 1,
  saveStatus: 0,
  error: null,
};

const gameDetailInitialState = {
  helpList: null,
  count: 0,
  joinResult: null,
  joinCount: 0,
  loadStatus: 0,
  saveStatus: 0,
};

const sslDetailInitialState = {
  ownGameId: null,
  canCreate: false,
  loadStatus: 0,
};

function createSslReducer(state = createSslInitialState, action) {
  switch (action.type) {
    case 'CREATE_SSL': {
      return {
        ...state,
        type: action.inviteGameId ? 2 : 1,
        saveStatus: 1,
      };
    }

    case 'CREATE_SSL_COMPLETION': {
      const { error, data } = action;
      let nextState = { ...state };

      nextState.saveStatus = error ? 0 : 2;

      if (data.errmsg) {
        nextState.error = data.errmsg;
      }

      return nextState;
    }

    default:
      return state;
  }
}

function gamesReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      const { game, type } = data;

      if (type !== 11 || !game) {
        return state;
      }

      const { gameId } = game;
      return {
        ...state,
        [gameId]: { ...state[gameId], ...game },
      };
    }
    case 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE_COMPLETION':
    case 'LOAD_SSL_DETAIL_WITH_GAME_ID_COMPLETION': {
      const { error, data } = action;
      const { game } = data;

      if (error || !game) {
        return state;
      }

      const { gameId } = game;
      return {
        ...state,
        [gameId]: { ...state[gameId], ...game },
      };
    }
    case 'CREATE_SSL_COMPLETION': {
      const { error, data } = action;

      if (error || !data.sslGame) {
        return state;
      }

      const { gameId } = data.sslGame;
      return {
        ...state,
        [gameId]: data.sslGame,
      };
    }
    default:
      return state;
  }
}

function gameDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT_COMPLETION': {
      const { data, error } = action;

      if (error) {
        return state;
      }

      const { game, joinResult, type } = data;

      if (type !== 11 || !game) {
        return state;
      }

      const { gameId } = game;
      const prevState = state[gameId] || gameDetailInitialState;
      let nextState = {};

      if (joinResult) {
        nextState.joinResult = joinResult;
      }

      return {
        ...state,
        [gameId]: {
          ...prevState,
          ...nextState,
        },
      };
    }
    case 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE_COMPLETION':
    case 'LOAD_SSL_DETAIL_WITH_GAME_ID_COMPLETION': {
      const { error, data } = action;
      const { joinResult, game } = data;

      if (error || !game) {
        return state;
      }

      const { gameId } = game;
      const prevState = state[gameId] || gameDetailInitialState;
      let nextState = {};

      if (joinResult) {
        nextState.joinResult = joinResult;
      }

      return {
        ...state,
        [gameId]: {
          ...prevState,
          ...nextState,
        },
      };
    }
    case 'LOAD_SSL_HELP_LIST': {
      const { gameId } = action;
      const prevState = state[gameId] || gameDetailInitialState;

      return {
        ...state,
        [gameId]: {
          ...prevState,
          helpList: null,
          count: 0,
          loadStatus: 1,
        },
      };
    }

    case 'LOAD_SSL_HELP_LIST_COMPLETION': {
      const { error, list, gameId, count } = action;
      const prevState = state[gameId] || gameDetailInitialState;

      if (error) {
        return {
          ...state,
          [gameId]: {
            ...prevState,
            loadStatus: 0,
          },
        };
      }

      return {
        ...state,
        [gameId]: {
          ...prevState,
          helpList: list,
          count,
          loadStatus: 2,
        },
      };
    }

    case 'CREATE_SSL_COMPLETION': {
      const { error, data, inviteGameId } = action;

      if (error) {
        return state;
      }

      const { sslGame, joinCount } = data;
      let nextState = {};

      if (sslGame) {
        nextState[sslGame.gameId] =
          state[sslGame.gameId] || gameDetailInitialState;
      }

      if (joinCount) {
        nextState[inviteGameId] = {
          ...(state[inviteGameId] || gameDetailInitialState),
          joinCount,
        };
      }

      return {
        ...state,
        ...nextState,
      };
    }

    default:
      return state;
  }
}

function sslsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT_COMPLETION': {
      const { productId, data, error } = action;

      if (error) {
        return state;
      }

      const { activity, type } = data;

      if (type !== 11) {
        return state;
      }

      return {
        ...state,
        [productId]: { ...state[productId], ...activity },
      };
    }

    case 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE_COMPLETION': {
      const { productCode, error, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        [productCode]: { ...state[productCode], ...data.activity },
      };
    }
    case 'LOAD_SSL_DETAIL_WITH_GAME_ID_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return state;
      }

      const productCode = data.activity.productCode;
      return {
        ...state,
        [productCode]: { ...state[productCode], ...data.activity },
      };
    }

    default:
      return state;
  }
}

function sslDetailsReducer(state = {}, action) {
  switch (action.type) {
    case 'LOAD_PRODUCT_COMPLETION': {
      const { productId, data, error } = action;
      const prevState = state[productId] || sslDetailInitialState;

      if (error) {
        return prevState;
      }

      const { canCreate, game, type } = data;

      if (type !== 11) {
        return prevState;
      }

      return {
        ...state,
        [productId]: {
          ...prevState,
          canCreate,
          ownGameId: game && game.gameId,
        },
      };
    }
    case 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE': {
      const { productCode } = action;
      const prevState = state[productCode] || sslDetailInitialState;

      return {
        ...state,
        [productCode]: {
          ...prevState,
          loadStatus: 1,
        },
      };
    }
    case 'LOAD_SSL_DETAIL_WITH_PRODUCT_CODE_COMPLETION': {
      const { productCode, error, data } = action;
      const prevState = state[productCode] || sslDetailInitialState;

      if (error) {
        return {
          ...state,
          [productCode]: {
            ...prevState,
            loadStatus: 0,
          },
        };
      }

      const { canCreate, game } = data;

      return {
        ...state,
        [productCode]: {
          ...prevState,
          canCreate,
          ownGameId: game && game.gameId,
          loadStatus: 2,
        },
      };
    }
    case 'LOAD_SSL_DETAIL_WITH_GAME_ID_COMPLETION': {
      const { error, data } = action;
      const { productCode } = data.activity;
      const prevState = state[productCode] || sslDetailInitialState;

      if (error) {
        return state;
      }

      const { canCreate } = data;
      return {
        ...state,
        [productCode]: {
          ...prevState,
          canCreate,
        },
      };
    }

    case 'CREATE_SSL_COMPLETION': {
      const { error, data } = action;

      if (error || !data.sslGame) {
        return state;
      }

      const { productCode, gameId } = data.sslGame;
      const prevState = state[productCode] || sslDetailInitialState;
      return {
        ...state,
        [productCode]: { ...prevState, ownGameId: gameId },
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  create: createSslReducer,
  games: gamesReducer,
  gameDetails: gameDetailsReducer,
  ssls: sslsReducer,
  details: sslDetailsReducer,
});
